import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import UseEmpsTypes from '../../../hooks/use-emps-types'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { BsSearch } from 'react-icons/bs'
import LabelCustom from '../../../components/label-custom'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import { fnDateEn } from '../../../helper/fnDateEn'
import ModalCustom from '../../../components/modal-custom'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import UseGroups from '../../../hooks/use-groups'
import UseFactionAll from '../../../hooks/use-factions-all'
import UseDepartmentsAll from '../../../hooks/use-departmentsAll'
import UseTeams from '../../../hooks/use-teams'
import UsePositions from '../../../hooks/use-position'

export default function ModalFilter({
  roleId,
  open,
  onCancel,
  fnGetData,
  isLoading,
  bodyFilter
}) {
  const { control, setValue, handleSubmit } = useForm()

  const empsTypes = UseEmpsTypes()

  const [divisionId, setDivisionId] = useState(0)
  const [factionId, setFactionId] = useState(0)
  const [departmentId, setDepartmentId] = useState(0)
  const [teamId, setTeamId] = useState(0)

  const empsDivision = UseGroups(roleId) //สายงาน
  const empFactions = UseFactionAll(roleId, divisionId)
  const empsDepartment = UseDepartmentsAll(roleId, divisionId, factionId) //แผนก
  const empstTeams = UseTeams(roleId, divisionId, departmentId) //ทีม
  const empPosition = UsePositions(roleId, divisionId, departmentId, teamId) //ตำแน่ง

  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)

  useEffect(() => {
    const d = bodyFilter

    d?.works && setValue('department', d?.works)

    if (d?.typeId) {
      const dataNew = empsTypes.find((item) => item.value === d?.typeId)
      d?.typeId && setValue('typeId', dataNew)
    }

    if (d?.dsId) {
      setDivisionId(d?.dsId ?? 0)
    }

    if (d?.facId) {
      setFactionId(d?.facId ?? 0)
    }

    if (d?.dmId) {
      setDepartmentId(d?.dmId ?? 0)
    }

    if (d?.teamId) {
      setTeamId(d?.teamId ?? 0)
    }

    d?.startDate && setValue('startDate', new Date(d.startDate))
    d?.endDate && setValue('endDate', new Date(d.endDate))

    setEndDate(new Date(d.endDate))
    setStartDate(new Date(d.startDate))
    d?.probation &&
      setValue('probation', { value: d?.probationId, label: d?.probation })
    d?.typeDate &&
      setValue('typeDate', { value: d?.typeDate, label: d?.typeDateLabel })
    d?.username &&
      setValue('username', { value: d?.username, label: d?.username })

    d?.identity && setValue('identity', d?.identity)
    d?.nickname && setValue('nickname', d?.nickname)
    d?.searchs && setValue('search', d?.searchs)
  }, [bodyFilter, empsTypes, setValue])

  useEffect(() => {
    if (teamId) {
      const dataNew = empstTeams.find((item) => item.value === teamId)

      if (bodyFilter?.positionId) {
        const dataNew = empPosition.find(
          (item) => item.value === bodyFilter?.positionId
        )
        bodyFilter?.positionId && setValue('position', dataNew)
      }

      setValue('team', dataNew)
    } else {
      setValue('team', null)
      setValue('position', null)
    }
  }, [empstTeams, setValue, teamId, bodyFilter, empPosition])

  useEffect(() => {
    if (departmentId) {
      const dataNew = empsDepartment.find((item) => item.value === departmentId)
      setValue('department', dataNew)
    } else {
      setValue('department', null)
    }
  }, [empsDepartment, setValue, departmentId])

  useEffect(() => {
    if (factionId) {
      const dataNew = empFactions.find((item) => item.value === factionId)
      setValue('faction', dataNew)
    } else {
      setValue('faction', null)
    }
  }, [empFactions, setValue, factionId])

  useEffect(() => {
    if (divisionId) {
      const dataNew = empsDivision.find((item) => item.value === divisionId)
      setValue('division', dataNew)
    } else {
      setValue('division', null)
    }
  }, [empsDivision, setValue, divisionId])

  const onSubmit = (d) => {
    const datas = {
      startDate: fnDateEn(d.startDate).format('YYYY-MM-DD'),
      endDate: fnDateEn(d.endDate).format('YYYY-MM-DD'),
      dsId: d.division?.value ?? '',
      facId: d.faction?.value ?? '',
      dmId: d.department?.value ?? '',
      teamId: d.team?.value ?? '',
      positionId: d.position?.value ?? '',
      typeId: d.typeId?.value ?? ''
    }
    const body = {
      page: 1,
      orgId: roleId,
      size: 20,
      ...datas
    }

    fnGetData({ ...bodyFilter, ...body })
    onCancel()
  }

  return (
    <ModalCustom width={1200} open={open} onCancel={onCancel}>
      <h4>Filter</h4>
      <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
        <Row style={{ rowGap: '25px' }}>
          <Col xl={4}>
            <LabelCustom text={'Check-in Start Date'} />
            <Controller
              name={'startDate'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <CustomDatePicker
                  isClearable={false}
                  value={value}
                  maxDate={endDate}
                  onChange={(d) => {
                    if (d) {
                      setStartDate(d)
                      onChange(d)
                    }
                  }}
                  showYearDropdown
                  showMonthDropdown
                />
              )}
            />
          </Col>
          <Col xl={4}>
            <LabelCustom text={'Check-in End Date'} />
            <Controller
              name={'endDate'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <CustomDatePicker
                  isClearable={false}
                  value={value}
                  minDate={startDate}
                  onChange={(d) => {
                    if (d) {
                      setEndDate(d)
                      onChange(d)
                    }
                  }}
                  showYearDropdown
                  showMonthDropdown
                />
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="ประเภทพนักงาน" />
            <Controller
              name={'typeId'}
              control={control}
              render={({ field: { onChange, value = [] } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  placeholder={``}
                  options={empsTypes}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="สายงาน " />
            <Controller
              name={'division'}
              control={control}
              render={({ field: { value = null, onChange } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  value={value}
                  placeholder=""
                  options={empsDivision}
                  onChange={(data) => {
                    onChange(data)
                    setDivisionId(data?.value ?? 0)

                    setFactionId(0)
                    setTeamId(0)
                    setDepartmentId(0)

                    setValue('team', null)
                    setValue('position', null)
                    setValue('department', null)
                    setValue('faction', null)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="ฝ่าย " />
            <Controller
              name={'faction'}
              control={control}
              render={({ field: { value = null, onChange } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  disabled={!(divisionId > 0)}
                  value={value}
                  placeholder=""
                  options={empFactions}
                  onChange={(data) => {
                    onChange(data)
                    setFactionId(data?.value ?? 0)
                    setTeamId(0)
                    setDepartmentId(0)
                    setValue('team', null)
                    setValue('position', null)
                    setValue('department', null)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="แผนก " />
            <Controller
              name={'department'}
              control={control}
              render={({ field: { value = null, onChange } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  value={value}
                  disabled={!(factionId > 0)}
                  placeholder=""
                  options={empsDepartment}
                  onChange={(data) => {
                    onChange(data)
                    setDepartmentId(data?.value ?? 0)
                    setTeamId(0)
                    setValue('team', null)
                    setValue('position', null)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="ทีม " />
            <Controller
              name={'team'}
              control={control}
              render={({ field: { value = null, onChange } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  value={value}
                  disabled={!(departmentId > 0)}
                  placeholder=""
                  options={empstTeams}
                  onChange={(data) => {
                    onChange(data)
                    setTeamId(data?.value ?? 0)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={4} md={6}>
            <LabelCustom text="ตำแหน่ง " />
            <Controller
              name={'position'}
              control={control}
              render={({ field: { value = null, onChange } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  value={value}
                  disabled={!(teamId > 0)}
                  placeholder=""
                  options={empPosition}
                  onChange={(data) => {
                    onChange(data)
                  }}
                />
              )}
            />
          </Col>

          <Col xl={12} md={12} className="align-self-center text-center">
            <Button type="submit" disabled={isLoading} className=" px-4">
              <BsSearch /> ค้นหา{isLoading && '...'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
